function TogglePassive(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={45}
            height={20}
            viewBox="0 0 45 20"
            {...props}
        >
            <g fill="none" fillRule="evenodd">
                <rect width={45} height={20} fill="#ADB5BD" rx={10} />
                <circle cx={10} cy={10} r={9} fill="#FFF" />
            </g>
        </svg>
    );
}

export default TogglePassive;
